
import {
  computed,
  ref,
  watch
} from '@nuxtjs/composition-api'

export default {
  props: {
    disable: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'tertiary'
    },
    counterValue: {
      type: Number,
      default: 0
    }
  },
  emits: ['change'],
  setup (props, { emit }) {
    const counter = ref(0)
    const updatedCounter = computed(() => props.counterValue)


    const onClickUp = () => {
      emit('change', { value: 1, count: counter.value, event: 'up' })
    }

    const onClickDown = () => {
      emit('change', { value: -1, count: counter.value, event: 'down' })
    }

    watch(updatedCounter, (val) => {
      counter.value = val
    })

    return {
      counter,
      onClickUp,
      onClickDown
    }
  },
  computed: {
    value: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  }
}
